/* eslint-disable no-multi-str */
import React from 'react'
import Select from 'react-select'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  User,
  FormRow,
  LinkAdder,
  SaveCancel,
} from '../../../components'
import { Editor } from '@tinymce/tinymce-react'

const Form = () => {
  const [loading, setLoading] = React.useState(true)
  const handleEditorChange = (e) => {
    console.log(e)
  }

  return (
    <form>
      <p className="text-lg font-bold mb-5 lg:mb-8">Profile</p>
      <FormRow>
        <Label>Name</Label>
        <Input className="w-full" />
      </FormRow>
      <div className="flex flex-wrap -mx-4 mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Status</Label>
          <Select className="text-sm" options={[]}/>
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <Label>Institution/Company</Label>
          <Input className="w-full" />
        </div>
      </div>

      <div className="mb-5 lg:mb-10">
        {
          !loading &&
          <Label>About Me</Label>
        }
        <Editor
          apiKey="p92e8neygbpdv4yznm7pvlowzukov64286chr8rkq5td7s1z"
          initialValue="<p>This is the initial content of the editor</p>"
          init={{
            height: 500,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor image link | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help'
          }}
          onEditorChange={handleEditorChange}
          onInit={() => setLoading(false)}
        />
      </div>

      <hr className="my-5 lg:my-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">Organization</p>
      <div>
        <Label>Invited by Organization</Label>
        <div className="rounded py-5 px-4" style={{background: '#f9f9f9'}}>
          <User />
        </div>
      </div>

      <hr className="my-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">Social Media (Optional)</p>
      <FormRow>
        <LinkAdder
          prefix="facebook.com"
          label="Facebook"
          defaultState={true}
          defaultValue="peacegen_id"
        />
      </FormRow>
      <FormRow>
        <LinkAdder
          prefix="instagram.com"
          label="Instagram"
          defaultState={true}
          defaultValue="peacegen_id"
        />
      </FormRow>
      <FormRow>
        <LinkAdder
          prefix="youtube.com"
          label="Youtube"
          defaultState={true}
        />
      </FormRow>

      <hr className="hidden lg:block my-8 lg:my-10"/>

      <div className="mb-8 lg:mb-16">
        <LinkAdder className="mb-5" prefix="twitter.com" label="Twitter"/>
        <LinkAdder className="mb-5" prefix="linkedin.com" label="LinkedIn"/>
        <LinkAdder className="mb-5" prefix="medium.com" label="Medium"/>
        <LinkAdder className="mb-5" prefix="pinterest.com" label="Pinterest"/>
        <LinkAdder className="mb-5" prefix="" label="Other Link(s)"/>
      </div>

      <SaveCancel />
    </form>
  )
}

export { Form }